import { useDidMount, useUpdateEffect } from 'utils/hooks';

export const useAddToFolderModalLifecyle = ({ localState, handlers }) => {
  useDidMount(handlers.handleFetchSavedFolders);

  useDidMount(handlers.handleFetchFolders);

  useUpdateEffect(handlers.handleFetchFolders, [localState.folderPaths]);
};
